import request from "@/utils/request"

// 查询增值服务信息列表
export function getRewardList(query) {
  return request({
    url: "/server/reward/list",
    method: "get",
    params: query,
  })
}
// 查询增值服务信息列表
export function editReward(data) {
  return request({
    url: "/server/reward/edit",
    method: "post",
    data: data,
  })
}
